import PaginationContext from '@jetshop/core/components/Pagination/PaginationContext';
import { PaginationBehaviour } from '@jetshop/ui/Pagination';
import React, { Component } from 'react';
import GridProduct from '../GridProduct';
import ListProduct from '../ListProduct';
import Pagination from '../Pagination';
import ProductGrid from '../ProductGrid';
import ProductList from '../ProductList';

export default class Products extends Component {
  render() {
    const { category, loading, productView } = this.props;
    return (
      <React.Fragment>
        {productView === 'grid' ? (
          <ProductGrid
            products={category.products.result}
            listName={category.name}
            categoryPath={category.primaryRoute}
            loading={loading}
            ProductComponent={GridProduct}
            mainCat={category.id}
          />
        ) : null}
        {productView === 'list' ? (
          <ProductList
            products={category.products.result}
            listName={category.name}
            categoryPath={category.primaryRoute}
            loading={loading}
            ProductComponent={ListProduct}
            mainCat={category.id}
          />
        ) : null}
        <PaginationContext.Consumer>
          {({ currentPage, goToPage, perPage }) => (
            <PaginationBehaviour
              currentPage={currentPage}
              goToPage={goToPage}
              perPage={perPage}
              total={category.products.totalResults}
            >
              {(props) => <Pagination {...props} />}
            </PaginationBehaviour>
          )}
        </PaginationContext.Consumer>
      </React.Fragment>
    );
  }
}
